import { render, staticRenderFns } from "./GeneralSetting.vue?vue&type=template&id=44f4da92&"
import script from "./GeneralSetting.vue?vue&type=script&lang=js&"
export * from "./GeneralSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports